module.exports = __webpack_public_path__ + "img/20250813SelmaFynn-73.940e3e1b.jpg";